import React from 'react';
import type { BuildoutListing } from '../../types';
import BuildoutListingRow from './row';
import { connect } from 'react-redux';
import { setFlash, setSortOrder, updateListingGuid } from '../../store/actions';

type BuildoutListingsTableProps = {
  listings: BuildoutListing[];
  updateListingGuid: (guid: string, buildoutListingId: number) => void;
  setFlash: (message?: string | null, variant?: string) => void;
}

function BuildoutListingsTable(
  { listings, setFlash, updateListingGuid } : BuildoutListingsTableProps
) {
  return (
    <div>
      <h6>Buildout Listings ({listings.length})</h6>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Type/ID</th>
            <th>Name</th>
            <th>Location</th>
            <th>Status</th>
            <th>GUID</th>
          </tr>
        </thead>
        <tbody>
          {listings.map(listing => (
            <BuildoutListingRow
              key={listing.id}
              listing={listing}
              setFlash={setFlash}
              updateListingGuid={updateListingGuid}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
const mapStateToProps = (state: any) => ({
  listings: state.listings.unmatchedBuildoutListings,
  sort: state.listings.sort
});

export default connect(mapStateToProps, { updateListingGuid, setFlash, setSortOrder })(BuildoutListingsTable);
